import React, { useEffect } from 'react'
import { useTheme } from '../Context/ThemeContext';

function Theme() {

    const { primaryColor, secondaryColor, theme, border, handleThemeChange } = useTheme();

    useEffect(() => {
    }, [theme, border, primaryColor, secondaryColor]);

    return (
        <div className='font-bold mx-3'>
            {theme === 'dark' &&
                <i onClick={() => handleThemeChange('light')} className={`fa-solid fa-sun ${secondaryColor} hover:${primaryColor} cursor-pointer rounded-full border-2 circle p-2`} style={{ borderColor: border }}></i>}
            {theme === 'light' &&
                <i onClick={() => handleThemeChange('dark')} className={`fa-solid fa-moon ${secondaryColor} hover:${primaryColor} cursor-pointer rounded-full border-2 circle p-2`} style={{ borderColor: border }}></i>}
        </div>
    )
}

export default Theme